import React, { useEffect, useRef, useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import "./Dialog.scss";
import ReactDOM from "react-dom";
import { useParams } from "react-router-dom";

import "react-image-crop/dist/ReactCrop.css";
import "./loader.css";
import { ImageCard } from "./image-card";
import { formatDate } from "../../utils/formats";
import MultiStepper from "./multi-stepper";
import useModelStore from "../../store/model-store";

function Modal({ isOpen, onClose, loading, children }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.focus();
    }
  }, [isOpen]);

  let portalRoot = document.getElementById("modal");
  if (!portalRoot) {
    portalRoot = document.createElement("div");
    portalRoot.setAttribute("id", "modal");
    document.body.appendChild(portalRoot);
  }
  const displayClass = isOpen ? "show" : "hide";

  return ReactDOM.createPortal(
    <div id="modal-comp" className={displayClass} isOpen={isOpen}>
      <div className="dialog" ref={dialogRef} tabIndex={1}>
        {children}
      </div>
    </div>,
    portalRoot
  );
}

function Close(props) {
  return <IoCloseSharp className="close-svg" {...props} />;
}

const DialogSelect = ({ visible, toggleDialog, leadDetail, reload }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const { modelData, setModelData } = useModelStore();
  const [scanType, setScanType] = useState(null);
  const [isUsed, setIsUsed] = useState(false);
  const [output, setOutput] = useState(null);
  const [visible2, setVisible2] = useState(false);
  const [file, setFile] = useState(null);



  const initialImageCards = [
    { title: "Front of Home", keyForAPi: "frontOfHome" },
    { title: "Front-Left", keyForAPi: "frontLeft" },
    { title: "Front-Right", keyForAPi: "frontRight" },
    { title: "Right Side", keyForAPi: "rightSide" },
    { title: "Inside Box gutter", keyForAPi: "insideBoxGutter" },
    { title: "Inside Super Gutter", keyForAPi: "insideSuperGutter" },
    { title: "Box Gutter Measurement", keyForAPi: "boxGutterMeasurements" },
    { title: "Super Gutter Measurement", keyForAPi: "superGutterMeasurements" },
    { title: "Back-Right", keyForAPi: "backRight" },
    { title: "Fascia Board Width", keyForAPi: "fasciaBoardWidth" },
    { title: "Fascia Board Height", keyForAPi: "fasciaBoardHeight" },
    {
      title: "Soffit Width House to Edge",
      keyForAPi: "soffitWidthHousetoEdge",
    },
  ];

  const [imageCards, setImageCards] = useState(initialImageCards);

  useEffect(() => {
    const updatedCards = initialImageCards.map((card) => ({
      ...card,
      imageUrl: leadDetail?.compressedImages[card.keyForAPi] || null, // Add imageUrl if exists
    }));

    setImageCards(updatedCards);
  }, []);


  const [imagesData, setImagesData] = useState([]);
  const [deleteAbleKeys, setDeleteAbleKeys] = useState([]);
  const handleImageChange = async (title, keyForAPi, file, imageData) => {
    if (!file) {
      const filterItems = imagesData.filter(
        (items) => items.keyForAPi != keyForAPi
      );
      setImagesData(filterItems);
      setDeleteAbleKeys((prev) => [...prev, keyForAPi]);
      return;
    } else {
      const filterItems = deleteAbleKeys.filter((items) => items != keyForAPi);
      setDeleteAbleKeys(filterItems);
      setImagesData((prev) => [
        ...prev,
        { file, imageData, keyForAPi, imageUrl: null },
      ]);
    }
  };

  const formatmyDate = (inputDate) => {
    const [day, month, year] = inputDate.split("-");
    const formattedDate = `${month}/${day}/${year}`;
    return formattedDate;
  };
  return (
    <div className="container-dailog">
      <Modal
        isOpen={modelData.open}
        onClose={() => toggleDialog()}
        loading={loading}
      >
        <div className="modal-title-container">
          <div className="modal-title">Lead Details</div>
          <Close onClick={() => toggleDialog()} />
        </div>
        <div
          className={`k-pt-${
            file ? 2 : 0
          } k-pb-8 k-px-2 k-less-padding k-scrollable`}
        >
          <div className="card-detail-lead">
            <h4 style={{ margin: 0, fontWeight: "lighter" }}>
              <div style={{ fontWeight: "bold" }}>Lead Name:</div>{" "}
              {leadDetail.name}{" "}
            </h4>
            <h4 style={{ margin: 0, fontWeight: "lighter" }}>
              <div style={{ fontWeight: "bold" }}>ID:</div> {leadDetail.code}{" "}
            </h4>
            <h4 style={{ margin: 0, fontWeight: "lighter" }}>
              <div style={{ fontWeight: "bold" }}>MKT CODE:</div>{" "}
              {leadDetail.leadId}{" "}
            </h4>
            <h4 style={{ margin: 0, fontWeight: "lighter" }}>
              <div style={{ fontWeight: "bold" }}>Date:</div>{" "}
              {formatmyDate(formatDate(leadDetail.time))}{" "}
            </h4>
          </div>
        </div>

        <MultiStepper leadDetail={leadDetail} reload={reload} />
      </Modal>

      <Modal
        isOpen={visible2}
        onClose={() => {
          setVisible2(false);
        }}
        loading={loading}
      >
        <div className="modal-title-container">
          <div className="modal-title"></div>
          <Close
            onClick={() => {
              setVisible2(false);
            }}
          />
        </div>
        <div className={`k-py-4 k-px-2 k-less-padding k-scrollable`}>
          <div className="k-text-center">
            <h1 className="k-font-semibold k-sm-heading">Upload Images</h1>
          </div>
          <div className="k-d-grid k-gap-3 image-grid">
            {imageCards.length > 0 &&
              imageCards.map((card, index) => (
                <ImageCard
                  key={index}
                  title={card.title}
                  keyForAPi={card.keyForAPi}
                  initialImage={card.imageUrl}
                  onImageChange={handleImageChange}
                />
              ))}
          </div>
        </div>
      </Modal>

      {scanType == "Upload Image" && loading && (
        <div class="loader-overlay-calander">
          <div
            className="k-my-10 k-rounded-lg k-p-4 "
            style={{ backgroundColor: "#F3F3F3" }}
          >
            <div id="dup-scanning-files">
              <div class="scanning-wrapper">
                <div class="top-corners"></div>
                <div class="bottom-corners"></div>
                <div class="file-types">
                  <img
                    style={{ objectFit: "contain", height: "500px" }}
                    src={isUsed ? output : URL.createObjectURL(file)}
                    alt="Screenshot"
                  />
                </div>
                <div class="scanner"></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DialogSelect;
